/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import Table from 'components/Table';
import { getTiposJornadasNominas } from 'api/catalogos/tiposJornadasNominas';
import { checkToken } from 'api/utils';

export const tipojornadanominaPermission = {
  permissionModel: 'tipojornadanomina',
  catalogsModels: [],
  tabsModels: [],
};

const TipoJornada = ({ permission }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
      ] = await Promise.all([
        getTiposJornadasNominas(),
      ]);
      if (mounted) {
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 100,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 200,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          permission={permission}
          allowExportPDF={false}
        />
      </Spin>
    </Row>
  );
};

export default TipoJornada;
